import type { User } from '@prisma/client';

import { EPricingTier } from '~/utils/types.ts';

import { Free, Basic, Full } from '~/components/atoms/Pricing/index.tsx';

export const renderSwitch = (user: Pick<User, 'pricingTier'> | null) => {
	switch (user?.pricingTier ?? null) {
		case EPricingTier.Free:
			return (
				<ul className="pricing">
					{Free({ isCurrent: true })}
					{Basic({ isCurrent: false, isLoggedIn: !!user })}
					{Full({ isCurrent: false, isLoggedIn: !!user })}
				</ul>
			);
		case EPricingTier.Basic:
			return (
				<ul className="pricing">
					{Basic({ isCurrent: true, isLoggedIn: !!user })}
					{Full({ isCurrent: false, isLoggedIn: !!user })}
				</ul>
			);
		case EPricingTier.Full:
			return (
				<>
					<p>You're already on the highest tier!</p>
					<ul className="pricing">
						{Free({ isCurrent: false })}
						{Basic({ isCurrent: false, isLoggedIn: !!user })}
						{Full({ isCurrent: true, isLoggedIn: !!user })}
					</ul>
				</>
			);
		default:
			return (
				<ul className="pricing">
					{Free({ isCurrent: false })}
					{Basic({ isCurrent: false, isLoggedIn: !!user })}
					{Full({ isCurrent: false, isLoggedIn: !!user })}
				</ul>
			);
	}
};
